import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { addPageData, navigateWizard } from '../../actions';
import QuestionPageLayout from '../../components/QuestionPageLayout';
import analytics from '../../lib/analytics';
import { currencyFormattedNumber } from '../../lib/numberFormatter';
import * as payloadFactory from '../../lib/pageDataPayloadFactory';
import { periodPropTypes } from '../../reducers/propTypes';
import { periodSelector, hasPaidDepositSelector } from '../../reducers/selectors';

const DepositPage = ({ initialHasPaidDeposit, dispatchAddPageData, dispatchWizardNav, period }) => {
  const { deposit, currency } = period;
  const formattedDepositAmount = currencyFormattedNumber(currency, deposit);

  const handleSubmit = hasPaidDeposit => {
    analytics.sendEvent('Click - Next', 'deposit');

    const payloadDeposit = payloadFactory.createAddPageDataPayload('depositAmount', deposit);
    const payloadHaspaidDeposit = payloadFactory.createAddPageDataPayload(
      'hasPaidDeposit',
      hasPaidDeposit,
    );
    dispatchAddPageData(payloadDeposit);
    dispatchAddPageData(payloadHaspaidDeposit);

    dispatchWizardNav({ dir: 'fwd' });
  };

  return (
    <QuestionPageLayout
      id="has-paid-deposit"
      value={initialHasPaidDeposit}
      title={`Have you paid the ${formattedDepositAmount} deposit to your school yet?`}
      onSubmit={handleSubmit}
      helpText=" We need to know this to work out how much you need to borrow. We'll confirm this with your school when we finalise your loan."
    />
  );
};

DepositPage.propTypes = {
  initialHasPaidDeposit: PropTypes.bool,
  dispatchAddPageData: PropTypes.func.isRequired,
  dispatchWizardNav: PropTypes.func.isRequired,
  period: periodPropTypes.isRequired,
};

DepositPage.defaultProps = {
  initialHasPaidDeposit: null,
};

export const mapStateToProps = state => ({
  initialHasPaidDeposit: hasPaidDepositSelector(state),
  period: periodSelector(state),
});

export const mapDispatchToProps = {
  dispatchAddPageData: addPageData,
  dispatchWizardNav: navigateWizard,
};

export { DepositPage };

export default connect(mapStateToProps, mapDispatchToProps)(DepositPage);
